import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  cancelCheckinRetrieveInfo: {},
  isLoading: false,
  hasData: false,
  error: "",
  cancelRetrieveCheckinStatus: {
    status: false,
    message: ""
  }
};
const cancelRetrieveCheckinSlice = createSlice({
  name: "cancelRetreiveCheckin",
  initialState,
  reducers: {
    cancelRetrieveCheckinRequest: (state, action) => {
      state.isLoading = true;
    },
    cancelRetrieveCheckinSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.cancelCheckinRetrieveInfo = action.payload;
      state.cancelRetrieveCheckinStatus.status = true;
    },
    cancelRetrieveCheckinFailure: (state, action) => {
      state.isLoading = false;
      state.error = action?.payload?.response?.data;
      state.cancelCheckinRetrieveInfo = {};
      state.cancelRetrieveCheckinStatus.status = false;
    },
    resetRetrieveCheckin: state => {
      state.isLoading = true;
      state.error = "";
      state.cancelCheckinRetrieveInfo = {};
      state.cancelRetrieveCheckinStatus.status = false;
    },
    resetRetrieveCheckinStatus: state => {
      state.cancelRetrieveCheckinStatus.status = false;
    }
  }
});
export const {
  cancelRetrieveCheckinRequest,
  cancelRetrieveCheckinSuccess,
  cancelRetrieveCheckinFailure,
  resetRetrieveCheckin,
  resetRetrieveCheckinStatus
} = cancelRetrieveCheckinSlice.actions;
export default cancelRetrieveCheckinSlice.reducer;